module.exports = __webpack_public_path__ + "img/beeldschermbril-hoofd.6c915778.svg";